export const CURRENT_USER_ID = "me";

export const CURRENT_USER = {
  id: CURRENT_USER_ID,
  name: "You",
  designation: "Frontend Developer",
  company: "Your Organization",
};

export const SCREENS = {
  CONTACTS: "contacts",
  MEETINGS: "meetings",
};

export const MEETINGS_TABS = [
  { key: "requests", label: "Requests" },
  { key: "upcoming", label: "Upcoming" },
  { key: "past", label: "Past" },
];

export const MEETING_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  REJECTED: "rejected",
  RESCHEDULE_REQUESTED: "reschedule_requested",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
};

export const STATUS_LABELS = {
  [MEETING_STATUS.PENDING]: "Pending",
  [MEETING_STATUS.CONFIRMED]: "Confirmed",
  [MEETING_STATUS.REJECTED]: "Rejected",
  [MEETING_STATUS.RESCHEDULE_REQUESTED]: "Reschedule Requested",
  [MEETING_STATUS.CANCELLED]: "Cancelled",
  [MEETING_STATUS.COMPLETED]: "Completed",
};

export const DURATION_OPTIONS = [
  { value: 15, label: "15 Minutes" },
  { value: 30, label: "30 Minutes" },
  { value: 45, label: "45 Minutes" },
  { value: 60, label: "60 Minutes" },
];

export const TIME_SLOTS = Array.from({ length: 9 }, (_, i) => {
  const hour24 = 9 + i;
  const value = `${String(hour24).padStart(2, "0")}:00`;
  const period = hour24 >= 12 ? "PM" : "AM";
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return { value, label: `${hour12}:00 ${period}` };
});

export const MY_MEETINGS_TABS = [
  { key: "upcoming", label: "Upcoming" },
  { key: "requests", label: "Requests" },
  { key: "sent", label: "Sent" },
  { key: "past", label: "Past" },
];

export const EMPTY_FORM = {
  title: "",
  date: "",
  time: "",
  duration: "",
  message: "",
};

export const USERS = [
  {
    id: 1,
    name: "Anjali Sharma",
    designation: "Project Manager",
    company: "ABC Company",
    location: "New Delhi",
    description:
      "Leads cross-functional delivery teams with a focus on client-facing programs and on-time execution.",
  },
  {
    id: 2,
    name: "Rohit Verma",
    designation: "Business Development Manager",
    company: "XYZ Solutions",
    location: "Mumbai",
    description:
      "Builds partnerships across enterprise accounts, specializing in long-term B2B relationships.",
  },
  {
    id: 3,
    name: "Priya Nair",
    designation: "Product Design Lead",
    company: "Vertex Studio",
    location: "Bengaluru",
    description:
      "Oversees design systems and product experience for a portfolio of enterprise SaaS applications.",
  },
  {
    id: 4,
    name: "Karan Malhotra",
    designation: "Operations Director",
    company: "Northgate Logistics",
    location: "Gurugram",
    description:
      "Manages regional operations and vendor relationships across the northern logistics corridor.",
  },
  {
    id: 5,
    name: "Meera Iyer",
    designation: "Finance Controller",
    company: "Sundial Capital",
    location: "Chennai",
    description:
      "Oversees budgeting, forecasting, and financial reporting for the firm's advisory division.",
  },
  {
    id: 6,
    name: "Arjun Kapoor",
    designation: "Engineering Manager",
    company: "Bluewave Technologies",
    location: "Pune",
    description:
      "Leads platform engineering teams building scalable infrastructure for consumer products.",
  },
];
